import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import querySearch from "stringquery";
import TagManager from "react-gtm-module";
import { schema } from "./validations";
import { Checkbox, Error } from "../../styles/global";
import Button from "../../components/Button";
import Email from "../../components/Email";
import CustomHiddenInputs from "../../components/CustomHiddenInputs";
import HiddenInputs from "../../components/HiddenInputs";

import {
  Container,
  Text,
  Form,
  InputContainer,
  Input,
  Title,
  ClassInit,
  Class,
} from "./style";

const Home = ({ email, setEmail }) => {
  const url = "https://kenzie39049.activehosted.com/proc.php";

  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: { event: "lead-inscricao" },
    });
  });

  const location = useLocation();

  const { register, errors, watch, setError, clearErrors } = useForm({
    resolver: yupResolver(schema),
  });

  const [requirements, setRequirements] = useState("Sim");

  const [utmSource, setUtmSource] = useState("");
  const [utmCampaign, setUtmCampaign] = useState("");
  const [utmMedium, setUtmMedium] = useState("");
  const [utmContent, setUtmContent] = useState("");
  const [hsaAd, setHsaAd] = useState("");
  const [hsaGrp, setHsaGrp] = useState("");
  const [hsaCam, setHsaCam] = useState("");
  const [hsaSrc, setHsaSrc] = useState("");
  const [origemLancamento, setOrigemLancamento] = useState("");
  const [campanhaLancamento, setCampanhaLancamento] = useState("");
  const [emailIndicador, setEmailIndicador] = useState("");
  const [nomeIndicador, setNomeIndicador] = useState("");
  const [indicator, setIndicator] = useState("");
  const [referral, setReferral] = useState("");
  const [recommendationId, setRecommendationId] = useState("");
  const [utmTerm, setUtmTerm] = useState("");

  useEffect(() => {
    const urlParams = querySearch(location.search);

    setUtmSource(urlParams.utm_source);
    setUtmMedium(urlParams.utm_medium);
    setUtmCampaign(urlParams.utm_campaign);
    setUtmContent(urlParams.utm_content);
    setHsaAd(urlParams.hsa_ad);
    setHsaGrp(urlParams.hsa_grp);
    setHsaCam(urlParams.hsa_cam);
    setHsaSrc(urlParams.hsa_src);
    setOrigemLancamento(urlParams.origem_lancamento);
    setCampanhaLancamento(urlParams.campanha_lancamento);
    setEmailIndicador(urlParams.EMAIL_DO_INDICADOR);
    setNomeIndicador(urlParams.NOME_DO_INDICADOR);
    setIndicator(urlParams.utm_indicator);
    setReferral(urlParams.utm_referral);
    setRecommendationId(urlParams.utm_recommendation_id);
    setUtmTerm(urlParams.utm_term);
    sessionStorage.setItem("influencerId", "no-tracking");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const computer = watch(["field[12]"])["field[12]"];
  const about_employment = watch(["field[132]"])["field[132]"];
  const about_support = watch(["field[133]"])["field[133]"];
  const about_course = watch(["field[134]"])["field[134]"];
  const privacy = watch(["privacy"]).privacy;

  const errorsLenght = Object.keys(errors).length;

  const validateEmail = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;

  const onFieldBlank = (e) => {
    if (
      computer === null ||
      about_employment === null ||
      about_support === null ||
      about_course === null ||
      privacy === false ||
      email === "" ||
      !validateEmail.test(email)
    ) {
      e.preventDefault();

      if (validateEmail.test(email) === false) {
        setError("email", {
          message: "O e-mail deve ser formatado corretamente",
        });
      }

      if (email === "") {
        setError("email", { message: "Preencha esse campo obrigatório." });
      }

      if (privacy === false) {
        setError("privacy", {
          message: "Preencha este campo obrigatório",
        });
      }

      if (computer === null) {
        setError("prerequisito_computador", {
          message: "Preencha este campo obrigatório",
        });
      }

      if (about_employment === null) {
        setError("kenzie_empregabilidade", {
          message: "Preencha este campo obrigatório",
        });
      }

      if (about_support === null) {
        setError("kenzie_atendimento", {
          message: "Preencha este campo obrigatório",
        });
      }

      if (about_course === null) {
        setError("kenzie_formacao", {
          message: "Preencha este campo obrigatório",
        });
      }

      return false;
    }
    if (computer === "Não") {
      localStorage.setItem("@req", "false");
    } else {
      localStorage.setItem("@req", "true");
    }

    localStorage.setItem("email", email);

    return true;
  };

  useEffect(() => {
    if (computer !== null) {
      clearErrors("prerequisito_computador");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [computer]);

  useEffect(() => {
    if (about_employment !== null) {
      clearErrors("kenzie_empregabilidade");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [about_employment]);

  useEffect(() => {
    if (about_support !== null) {
      clearErrors("kenzie_atendimento");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [about_support]);

  useEffect(() => {
    if (about_course !== null) {
      clearErrors("kenzie_formacao");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [about_course]);

  useEffect(() => {
    if (privacy !== false) {
      clearErrors("privacy");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [privacy]);

  useEffect(() => {
    if (email !== "") {
      clearErrors("email");
    }

    if (validateEmail.test(email)) {
      clearErrors("email");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);

  return (
    <>
      <Container id="main">
        <Title>
          12 meses para iniciar a sua carreira na área de tecnologia
        </Title>

        <ClassInit> Início: 17 de Novembro de 2022</ClassInit>

        <Text>
          Bem vindo(a) ao processo seletivo da <Class>Kenzie.</Class> Por aqui
          você aprende programação <i>(front-end e back-end)</i> do ZERO em 12
          meses sem precisar de conhecimento prévio e ainda conta com
          oportunidades de de pagamento facilitado.
        </Text>

        <Text>
          Nosso CEO, Daniel Kriger, tem um vídeo para te dar uma explicação
          completa sobre o nosso processo seletivo:
        </Text>

        <iframe
          src="https://www.youtube.com/embed/UF6Ifkh7VCg?rel=0"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Kenzie Academy Brasil"
          description="Kenzie Academy Brasil"
        />

        <Form onSubmit={onFieldBlank} action={url} method="POST" validate>
          <HiddenInputs formId={155} />

          <Email
            inputRef={register}
            name="email"
            value={email}
            onChange={setEmail}
            error={errors.email?.message}
            label="E-mail:"
          />

          <h2>Pré-requisitos</h2>

          <Text>
            a&#41; Computador com pelo menos 8gb de memória RAM, 1.6GHz de
            processador e 256gb de armazenamento (SSD recomendável), além de
            internet banda larga de 10mb/s e uma webcam. Você tem o equipamento
            necessário?
          </Text>
          <div style={{ display: "none" }}>
            <InputContainer>
              <input
                type="text"
                value={requirements}
                name="field[13]"
                ref={register}
              />{" "}
            </InputContainer>
          </div>

          <Text>b&#41; Ter pelo menos 18 anos completos</Text>
          <Text>c&#41; Ter pelo menos ensino médio completo</Text>
          <Text>
            d&#41; Disponibilidade de horário: 9h às 15h, de segunda a sexta, e
            dedicação adicional de 10 horas/semana pelo período de 12 meses.
          </Text>
          <Text>Você atende aos requisitos anteriores?</Text>
          <InputContainer>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  value="Sim"
                  ref={register}
                  name="field[12]"
                  onChange={(e) => setRequirements(e.target.value)}
                />{" "}
                SIM
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  value="Não"
                  ref={register}
                  name="field[12]"
                  onChange={(e) => setRequirements(e.target.value)}
                />{" "}
                NÃO
              </label>
            </Checkbox>
          </InputContainer>
          <Error>
            {errorsLenght !== 0 && errors.prerequisito_computador?.message}
          </Error>

          <h2>Sobre a Kenzie</h2>

          <Text>
            a&#41; Você sabia que a Kenzie tem uma taxa de empregabilidade de
            98% dos alunos formados e já empregou em empresas como: IFood,
            Picpay, Positivo, Exame, Google e Nubank?
          </Text>
          <InputContainer>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  value="Sim"
                  ref={register}
                  name="field[132]"
                />{" "}
                SIM
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  value="Não"
                  ref={register}
                  name="field[132]"
                />{" "}
                NÃO
              </label>
            </Checkbox>
          </InputContainer>
          <Error>
            {errorsLenght !== 0 && errors.kenzie_empregabilidade?.message}
          </Error>

          <Text>
            b&#41; Você sabia que as aulas da Kenzie são ao vivo e os estudantes
            recebem atendimento personalizado e em tempo real?
          </Text>
          <InputContainer>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  value="Sim"
                  ref={register}
                  name="field[133]"
                />{" "}
                SIM
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  value="Não"
                  ref={register}
                  name="field[133]"
                />{" "}
                NÃO
              </label>
            </Checkbox>
          </InputContainer>
          <Error>
            {errorsLenght !== 0 && errors.kenzie_atendimento?.message}
          </Error>

          <Text>
            c&#41; Na formação Full Stack da Kenzie, você tem mais de 2.000
            horas de aula que abrange as tecnologias Front End e Back End, além
            de soft skills. Entre as linguagens e tecnologias aprendidas, estão
            HTML5, CSS3, JavaScript [ES6 +], React, Redux, TypeScript, Node.js,
            Python [Django e Flask] e SQL. Você sabia disso?
          </Text>
          <InputContainer>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  value="Sim"
                  ref={register}
                  name="field[134]"
                />{" "}
                SIM
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  value="Não"
                  ref={register}
                  name="field[134]"
                />{" "}
                NÃO
              </label>
            </Checkbox>
          </InputContainer>
          <Error>{errorsLenght !== 0 && errors.kenzie_formacao?.message}</Error>

          <Input>
            <label>
              <input type="checkbox" name="privacy" ref={register} /> Na
              qualidade de Usuário, declaro que li, compreendi e estou de acordo
              com os{" "}
              <a
                href="https://formulario-kenzie.vercel.app/termos-condicoes"
                target="_blank"
                rel="noreferrer"
              >
                Termos de Uso e com a Política de Privacidade*
              </a>
            </label>
          </Input>
          <Error>{errors.privacy?.message}</Error>

          {errorsLenght !== 0 && <p>Preencha todos os campos obrigatórios</p>}

          <CustomHiddenInputs
            values={[
              utmSource,
              utmMedium,
              utmCampaign,
              utmContent,
              utmTerm,
              hsaAd,
              hsaGrp,
              hsaCam,
              hsaSrc,
              origemLancamento,
              campanhaLancamento,
              emailIndicador,
              nomeIndicador,
              indicator,
              referral,
              recommendationId,
            ]}
          />

          <Button type="submit">Iniciar Inscrição</Button>
        </Form>
      </Container>
    </>
  );
};

export default Home;
